const state = {
    jurisdictionList: [], // 权限列表
}

const actions = {
    getPermissionsList({ commit }, data) {
        return new Promise((resolve)=>{
            if (data) {
                state.jurisdictionList = data
            }else {
                if (!state.jurisdictionList.length) {
                    state.jurisdictionList = JSON.parse(localStorage.getItem('1+XPermissionsList'))
                }
            }

            resolve(state.jurisdictionList)
        })
    },
}

const mutations = {
    setJurisdictionList(state, payload) {
        state.jurisdictionList = payload 
    }
}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}